import ManualHero from './ManualHero';

export default ManualHero;
